<template>
  <router-link
    :to="linkDestination"
    exact
    :class="{ 'is-active': isParentActive }"
  >
    <i :class="route.icon" />
    <span>{{ route.text }}</span>
    <span
      v-if="route.tag"
      class="chip"
    >Novidade</span>
  </router-link>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NavigationLink',
  props: {
    route: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      promoterID: (state) => state.user.userInfo.promoter_id,
    }),
    isFinanceiro() {
      return this.route.text === 'Financeiro';
    },
    linkDestination() {
      if (this.isFinanceiro) {
        return {
          name: 'promoters-commission',
          params: {
            id: this.promoterID ?? null,
          },
        };
      }
      return this.route.href;
    },
    /**
     * True when the current route is a declared child of this menu item.
     * Exact match is intentionally excluded — router-link-exact-active covers it.
     * Children are injected by TheNavigation via ROUTE_CHILDREN_MAP.
     */
    isParentActive() {
      const currentPath = this.$route.path;
      const children = this.route.children ?? [];

      if (currentPath === this.route.href) return false;

      return children.some((prefix) => currentPath.startsWith(prefix));
    },
  },
};
</script>
